import React, { useEffect, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';

export const base_url = process.env.REACT_APP_API_URL;

const ProfitLoss = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [userData, setUserData] = useState([]);
  const [totals, setTotals] = useState({
    totalWalletMoney: 0,
    totalProfit: 0,
    totalLoss: 0,
    netAll: 0,
  });

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchUserData = async (filters = {}) => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(base_url + '/api/webapi/profitLoss', filters, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      const aggregatedData = response?.data?.data || [];
      setUserData(aggregatedData);

      const calculatedTotals = aggregatedData.reduce((acc, user) => {
        return {
          totalWalletMoney: acc.totalWalletMoney + parseFloat(user.money || 0),
          totalProfit: acc.totalProfit + parseFloat(user.total_profit || 0),
          totalLoss: acc.totalLoss + parseFloat(user.total_loss || 0),
          netAll: acc.netAll + parseFloat(user.total_profit || 0) + parseFloat(user.total_loss || 0),
        };
      }, { totalWalletMoney: 0, totalProfit: 0, totalLoss: 0, netAll: 0 });

      setTotals(calculatedTotals);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleFilter = () => {
    if (!startDate || !endDate) return alert("Select both dates");
    fetchUserData({ startDate, endDate });
  };

  const handleReset = () => {
    setStartDate('');
    setEndDate('');
    setSearchTerm('');
    fetchUserData();
  };





  const filteredData = userData.filter(user =>
    // console.log(user)
    user?.username?.toLowerCase()?.includes(searchTerm.toLowerCase())
  );

  const sortedData = [...filteredData].sort((a, b) => parseFloat(b.total_loss) - parseFloat(a.total_loss));
  return (
    <div className="wrapper">
      {/* <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      /> */}
      <div className={`content-wrapper ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`} style={{ marginLeft: (!isMobile && isSidebarOpen) ? "" : "0", transition: "margin-left 0.3s ease" }}>
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Profit / Loss
          </h1>
          <div className="page-content browse">
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3 shadow-sm bg-light rounded">
                  <div className="row mb-3">
                    <div className="col-md-3 mb-2">
                      <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="form-control" />
                    </div>
                    <div className="col-md-3 mb-2">
                      <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="form-control" />
                    </div>
                    <div className="col-md-3 mb-2">
                      <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="form-control" placeholder="Search by Name" />
                    </div>
                    <div className="col-md-3 mb-2">
                      <button className="btn btn-primary mr-2" onClick={handleFilter}>Filter</button>
                      <button className="btn btn-secondary" onClick={handleReset}>Reset</button>
                    </div>
                  </div>

                  <div className="table-responsive panel-body">
                    <table className="table table-striped table-bordered table-hover w-100">
                      <thead className="thead-dark">
                        <tr className='border'>
                          <th className="text-center font-weight-bold">Name</th>
                          <th className="text-center font-weight-bold">Role</th>
                          <th className="text-center font-weight-bold">Profit</th>
                          <th className="text-center font-weight-bold">Loss</th>
                          <th className="text-center font-weight-bold">P/L</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.length > 0 ? (
                          sortedData.map((user, index) => {
                            const isUser = user.role === "user";

                            const profit = parseFloat(isUser ? user.total_profit || 0 : user.downline_loss || 0);
                            const loss = parseFloat(isUser ? user.total_loss || 0 : user.downline_profit || 0);
                            const pl = isUser
                              ? parseFloat(user.total_profit || 0) - parseFloat(user.total_loss || 0)
                              : parseFloat(user.downline_loss || 0) - parseFloat(user.downline_profit || 0);

                            return (
                              <tr key={index}>
                                <td className="text-center border">{user.username}</td>
                                <td className="text-center border">{user.role}</td>
                                <td className="text-center border">{profit.toFixed(2)}</td>
                                <td className="text-center border">{loss.toFixed(2)}</td>
                                <td className={`text-center border font-weight-bold ${pl >= 0 ? 'text-success' : 'text-danger'}`}>
                                  {pl.toFixed(2)}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitLoss;